import React from "react";
import { createIcon } from "@chakra-ui/react";

/**
 * A custom icon for the Companion mode.
 *
 * I could not find the icon in the FontAwesome library anywhere. It is closest to the fa-window-restore icon, but still different.
 *
 * Original file is @/assets/tabs.svg
 */
export const CompanionIcon = createIcon({
	displayName: "CompanionIcon",
	viewBox: "0 0 14 14",
	path: [
		<path
			d="M10.0625 14H1.60417C0.71925 14 0 13.2808 0 12.3958V5.6875C0 4.80258 0.71925 4.08333 1.60417 4.08333H10.0625C10.9474 4.08333 11.6667 4.80258 11.6667 5.6875V12.3958C11.6667 13.2808 10.9474 14 10.0625 14ZM1.60417 4.95833C1.20225 4.95833 0.875 5.28558 0.875 5.6875V12.3958C0.875 12.7978 1.20225 13.125 1.60417 13.125H10.0625C10.4644 13.125 10.7917 12.7978 10.7917 12.3958V5.6875C10.7917 5.28558 10.4644 4.95833 10.0625 4.95833H1.60417Z"
			fill="currentColor"
		/>,
		<path
			d="M11.2292 7H0.4375C0.196 7 0 6.804 0 6.5625C0 6.321 0.196 6.125 0.4375 6.125H11.2292C11.4707 6.125 11.6667 6.321 11.6667 6.5625C11.6667 6.804 11.4707 7 11.2292 7Z"
			fill="currentColor"
		/>,
		<path
			d="M13.5625 9.91667C13.321 9.91667 13.125 9.72067 13.125 9.47917V1.60417C13.125 1.20225 12.7978 0.875 12.3958 0.875H3.9375C3.53558 0.875 3.20833 1.20225 3.20833 1.60417V2.47917C3.20833 2.72067 3.01233 2.91667 2.77083 2.91667C2.52933 2.91667 2.33333 2.72067 2.33333 2.47917V1.60417C2.33333 0.71925 3.05258 0 3.9375 0H12.3958C13.2808 0 14 0.71925 14 1.60417V9.47917C14 9.72067 13.804 9.91667 13.5625 9.91667Z"
			fill="currentColor"
		/>,
		<path
			d="M13.5625 2.91667L2.77083 2.91667C2.52933 2.91667 2.33333 2.72067 2.33333 2.47917C2.33333 2.23767 2.52933 2.04167 2.77083 2.04167H13.5625C13.804 2.04167 14 2.23767 14 2.47917C14 2.72067 13.804 2.91667 13.5625 2.91667Z"
			fill="currentColor"
		/>,
	],
});
